import classNames from 'classnames';
import { useState, useRef, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { getIsPadWidth } from '@elem/utils/devices';
import gtm from '@/utils/gtm';

import DropBoxSearch from '../Header/DropBox/DropBoxSearch';
import HeaderLogo from '../HeaderCommon/HeaderLogo';
import HeaderSearch from '../HeaderCommon/HeaderSearch';
import HeaderStore from '../HeaderCommon/HeaderStore';
import HeaderToggleNav from '../HeaderCommon/HeaderToggleNav';
import HeaderUser from '../HeaderCommon/HeaderUser';
import HeaderNav from './HeaderNav';
import './HeaderV2.scss';

export default function HeaderV2({ headerList, gloproductlist }: { headerList?: any; gloproductlist?: any }) {
    const detailList = headerList?.detailList || [];
    const [searchOpen, setSearchOpen] = useState(false); //search
    const compCls = classNames('HeaderV2', {
        [`HeaderV2-search-open`]: searchOpen,
    });
    const mouseLeaveTimer = useRef<any>(1);
    const navRef = useRef<any>(null);
    const timerNumber = 400;

    // search-打开
    const searchOpenHandle = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'top_function',
            button_name: 'Search',
        });
        setSearchOpen(true);
    };
    // search-关闭
    const searchHideHandle = () => {
        setSearchOpen(false);
    };

    const mouseLeaveFHandle = () => {
        mouseLeaveTimer.current = setTimeout(() => {
            searchHideHandle();
        }, timerNumber - 100);
    };

    useEffect(() => {
        if (!sessionStorage.getItem('ef_search_ai_session_id')) {
            sessionStorage.setItem('ef_search_ai_session_id', uuidv4());
        }
    }, []);

    return (
        <div className={compCls}>
            <div className="HeaderV2-content">
                <div className="HeaderV2-l">
                    <HeaderLogo />
                </div>
                <HeaderNav detailList={detailList} handleSearchLeave={searchHideHandle} />
                <div className="HeaderV2-r">
                    <HeaderSearch callback={searchOpenHandle} />
                    <HeaderUser />
                    <HeaderStore />
                    <HeaderToggleNav />
                </div>
            </div>
            {searchOpen && (
                <div className="HeaderV2-search" onMouseLeave={mouseLeaveFHandle}>
                    <DropBoxSearch gloproductlist={gloproductlist} callback={searchHideHandle} />
                </div>
            )}
        </div>
    );
}
